/* eslint-disable @typescript-eslint/no-explicit-any */
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import ForcastPayableList from '@/components/Registry/BillToPay/ForecastPayableForm/ForcastPayableList';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function ForecastPayablePage({ route }: PageProps) {
  const intl = useIntl();

  return (
    <DefaultRouteTabs
      route={route.parent}
      persistSearchParams={false}
      permissions={route.permissions}
      extra={
        <SpaceForButton>
          <Link to="/app/financial/billToPay/forecastPayable/create">
            <Button
              disabled={
                !hasPermissions([
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_ADD_FORECAST_OF_ACCOUNTS_PAYABLE,
                ])
              }
              block
              type="primary"
            >
              <FormattedMessage id="predictions.searchBar.create" />
            </Button>
          </Link>
        </SpaceForButton>
      }
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <ForcastPayableList />
    </DefaultRouteTabs>
  );
}

export default ForecastPayablePage;
